import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { KeycloakProvider } from "./KeycloakProvider";
import getEnv from "./config";

const AUTH_ENABLED = getEnv("REACT_APP_AUTH_ENABLED") === "true";

ReactDOM.createRoot(document.getElementById("root")).render(
  AUTH_ENABLED ? (
    <KeycloakProvider>
      <App />
    </KeycloakProvider>
  ) : (
    <App />
  )
);
